var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import useWatch from '../../../../utils/hooks/useWatch';
import ContentInformation from '../InformationColumn/ContentInformation';
export default function FeatureListItem(_a) {
    var featureObject = _a.featureObject, setActiveContentInformation = _a.setActiveContentInformation, setActivationFromMobile = _a.setActivationFromMobile, itemActiveFromMobile = _a.itemActiveFromMobile, activeContentInformation = _a.activeContentInformation;
    var isItemActiveFromMobile = useMemo(function () {
        return itemActiveFromMobile &&
            itemActiveFromMobile.order === featureObject.order;
    }, [itemActiveFromMobile]);
    var isItemActive = useMemo(function () {
        return isItemActiveFromMobile ||
            (activeContentInformation &&
                activeContentInformation.order === featureObject.order);
    }, [isItemActiveFromMobile, activeContentInformation]);
    var activateFeatureItem = function (isHover, isFocus) {
        if (isHover === void 0) { isHover = false; }
        if (isFocus === void 0) { isFocus = false; }
        var isMobileViewport = window.visualViewport.width < 1024;
        if (isMobileViewport && (isHover || isFocus)) {
            return;
        }
        if (isMobileViewport) {
            var toggleBoolean = isItemActiveFromMobile ? null : featureObject;
            setActivationFromMobile(toggleBoolean);
            setActiveContentInformation(null);
        }
        else {
            setActiveContentInformation(featureObject);
            setActivationFromMobile(null);
        }
    };
    var mobileActivateFeatureItem = function (isHover, isFocus) {
        if (isHover === void 0) { isHover = false; }
        if (isFocus === void 0) { isFocus = false; }
        var isMobileViewport = window.visualViewport.width < 1024;
        if (isMobileViewport && (isHover || isFocus)) {
            return;
        }
        if (isMobileViewport) {
            var toggleBoolean = isItemActiveFromMobile ? null : featureObject;
            setActivationFromMobile(toggleBoolean);
            setActiveContentInformation(null);
        }
        else {
            setActiveContentInformation(featureObject);
            setActivationFromMobile(null);
        }
    };
    var deactivateFeatureItem = function (isBlur) {
        if (isBlur === void 0) { isBlur = false; }
        var isMobileViewport = window.visualViewport.width < 1024;
        if (!isBlur && !isMobileViewport) {
            setActiveContentInformation(null);
            setActivationFromMobile(null);
        }
    };
    var handleKeyPress = function (e) {
        if (e.keyCode === 27) {
            deactivateFeatureItem();
            featureItemLinkRef.current.blur();
        }
    };
    var isMobileViewport = window.visualViewport.width < 1024;
    useWatch(function () {
        if (isMobileViewport) {
            return;
        }
        if (!isItemActive) {
            featureItemLinkRef.current.blur();
        }
    }, isItemActive);
    var orderWithTwoDigits = ("" + featureObject.order).padStart(2, '0');
    var featureItemLinkRef = useRef(null);
    return (_jsxs("li", __assign({ onMouseEnter: function () { return activateFeatureItem(true); }, onClick: function () { return activateFeatureItem(); }, className: "jobs__features__item relative" }, { children: [_jsxs("a", __assign({ onFocus: function () { return activateFeatureItem(false, true); }, onBlur: function () { return deactivateFeatureItem(true); }, onKeyUp: handleKeyPress, role: "button", tabIndex: 0, 
                // href={isMobileViewport ? null : featureObject.href}
                href: isMobileViewport || (featureObject === null || featureObject === void 0 ? void 0 : featureObject.href) == ''
                    ? null
                    : featureObject === null || featureObject === void 0 ? void 0 : featureObject.href, ref: featureItemLinkRef, className: "jobs__features__item__wrapper " + (isItemActive
                    ? "jobs__features__item__wrapper--active text-enblue"
                    : "jobs__features__item__wrapper--default text-enblue-900") + " x flex cursor-pointer select-none items-center py-5 text-left transition-all duration-300 ease-in-out md:space-x-7 md:pl-0 md:pr-9 lg:space-x-14 lg:border-t-0" }, { children: [_jsx("small", __assign({ className: "jobs__features__item__order text-sm lg:text-sm font-semibold lg:text-base" }, { children: orderWithTwoDigits }), void 0),
                    _jsx("span", __assign({ className: "jobs__features__item__title ml-4 overflow-x-auto overflow-y-visible text-left font-normal lg:ml-0 lg:overflow-x-visible lg:whitespace-normal" }, { children: featureObject.title }), void 0)] }), void 0),
            _jsx("span", { className: "jobs__features__divider absolute bottom-0 h-0.5 w-full max-w-full lg:max-w-none border-item" }, void 0),
            isItemActiveFromMobile && (_jsxs(_Fragment, { children: [(featureObject === null || featureObject === void 0 ? void 0 : featureObject.href) !== '' && (_jsx("a", __assign({ className: "cta-area cta-position", href: featureObject.href, rel: "noreferrer" }, { children: _jsx("div", __assign({ className: "cta-arrow" }, { children: _jsx("div", { className: "cta-arrowhead" }, void 0) }), void 0) }), void 0)),
                    _jsx(ContentInformation, { mainContent: featureObject, isItemActiveFromMobile: isItemActiveFromMobile }, void 0)] }, void 0))] }), featureObject.title));
}
